import { FCM_CONFIG, VAPID_KEY } from '@/config';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
const fapp = initializeApp(JSON.parse(FCM_CONFIG));
let messaging = null;
try {
  messaging = getMessaging(fapp);
} catch (error) {
  console.log('Firebase initializing error.')
}
export const requestForToken = (reg, storage) => {
  return getToken(messaging, { serviceWorkerRegistration: reg, vapidKey: VAPID_KEY })
    .then((currentToken) => {
      if (currentToken) {
        if (!storage.getFCMToken('fcmToken')) {
          storage.setFCMToken('fcmToken', currentToken);
          storage.clearFCMToken('oldFcmToken');
        } else if (currentToken !== storage.getFCMToken('oldFcmToken')) {
          storage.setFCMToken('oldFcmToken', storage.getFCMToken('fcmToken'));
          storage.setFCMToken('fcmToken', currentToken);
        }
        return currentToken;
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
      }
      return;
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
      return;
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
